import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useAuth } from '../components/auth/AuthProvider';

const DynamoUtilsContext = createContext(null);

export const DynamoUtilsProvider = ({ children }) => {
  const { getTemporaryCredentials, user } = useAuth();
  const dynamoUtilsRef = useRef(null);

  useEffect(() => {
    const init = async () => {
      if (!user) return;
      const creds = await getTemporaryCredentials();
      if (creds && !dynamoUtilsRef.current) {
        const region = process.env.REACT_APP_AWS_REGION || 'us-west-2';
        const { DynamoDBClient } = await import('@aws-sdk/client-dynamodb');
        const { MathTutorDynamoUtils } = await import('../utils/DynamoDBUtils');
        const ddbClient = new DynamoDBClient({ credentials: creds, region });
        const dutils = new MathTutorDynamoUtils(ddbClient);
        dutils.setS3Client(creds, region);
        dutils.setTableName('ai-math-tutor-conversations');
        dynamoUtilsRef.current = dutils;
      }
    };
    init();
  }, [user, getTemporaryCredentials]);

  return (
    <DynamoUtilsContext.Provider value={dynamoUtilsRef}>
      {children}
    </DynamoUtilsContext.Provider>
  );
};

export const useDynamoUtils = () => useContext(DynamoUtilsContext);
